import { render, staticRenderFns } from "./dydp-accountStatistics-list.vue?vue&type=template&id=bce0c8ec"
import script from "./dydp-accountStatistics-list.vue?vue&type=script&lang=js"
export * from "./dydp-accountStatistics-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports